/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */

import orderBy from 'lodash/orderBy';
import Highlighter from 'react-highlight-words';

import CompanyTile from '~/images/Tiles/Segment/Company.svg';
import PersonTile from '~/images/Tiles/Segment/Person.svg';

import Caret from './Caret';
import Companies from './Companies.svg';
import DestinationsIcon from './DestinationsIcon.svg';
import Folder from './Folder.svg';
import People from './People.svg';
import Segment from './Segment.svg';
import styles from './styles';

const Category = ({
  collections,
  name,
  keepOpen,
  classes,
  setSelectedCategory,
  selectedCategory,
  setSelectedCollection,
  selectedCollection,
  selectSegment,
  search,
}) => {
  const selected = name === selectedCategory || !!search || keepOpen;
  const select = () => {
    setSelectedCategory(name);
  };

  const icons = {
    Person: <PersonTile className={classes.categoryTile} size={24} />,
    Company: <CompanyTile className={classes.categoryTile} size={24} />,
  };

  return (
    <div
      className={classnames(classes.root, {
        [classes.noCategoryName]: keepOpen,
      })}>
      {!keepOpen && (
        <div className={classes.categoryName} colSpan={3} onClick={select}>
          <Caret open={selected} />
          {icons[name]}
          {name} audiences
        </div>
      )}
      {selected && (
        <>
          {collections.map((collection) => {
            const selected =
              selectedCollection?.id === collection.id ||
              !!search ||
              collections.length === 1;

            return (
              <div key={collection.id}>
                {collection.segments.length > 0 && (
                  <div
                    onClick={() => setSelectedCollection(collection)}
                    className={classes.collectionName}>
                    <Caret open={selected} />
                    <Folder />
                    {collection.name}
                  </div>
                )}

                {selected &&
                  orderBy(collection.segments, (segment) =>
                    segment.name.toLowerCase(),
                  ).map((segment) => {
                    const destinationsCount =
                      (segment.enabledDestinationsCount || 0) +
                      (segment?.audiences?.totalCount || 0);

                    return (
                      <div
                        key={segment.id}
                        onClick={() => selectSegment(segment)}
                        className={classes.segment}>
                        <div className={classes.segmentName}>
                          <Segment />
                          <Highlighter
                            searchWords={[search]}
                            autoEscape
                            textToHighlight={segment.name}
                            highlightTag={({ children }) => (
                              <strong>{children}</strong>
                            )}
                          />
                        </div>
                        <div className={classes.destinations}>
                          {destinationsCount > 0 && (
                            <>
                              <DestinationsIcon
                                className={classes.segmentIcon}
                                segment={segment}
                              />
                              {destinationsCount.toLocaleString()}{' '}
                              {destinationsCount === 1
                                ? 'destination'
                                : 'destinations'}
                            </>
                          )}
                        </div>
                        <div className={classes.resultsCount}>
                          {name === 'Company' && <Companies />}
                          {name === 'Person' && <People />}
                          {(segment.resultsCount || 0).toLocaleString()}
                        </div>
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

Category.propTypes = {
  classes: PropTypes.object,
  keepOpen: PropTypes.bool,
  name: PropTypes.string.isRequired,
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      segments: PropTypes.array,
    }),
  ),
  onChange: PropTypes.func,
  setSelectedCategory: PropTypes.func,
  selectedCategory: PropTypes.string,
  setSelectedCollection: PropTypes.func,
  selectedCollection: PropTypes.object,
  selectSegment: PropTypes.func,
  search: PropTypes.string,
};

export default withStyles(styles)(Category);
